import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { roleMatchGuard } from './core/guards/role.guard';
import { ROLES } from './core/constants/role.constants';

export const routes: Routes = [
    {
        path: 'login',
        loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
    },
    {
        path: 'reset-password',
        loadComponent: () => import('./features/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
    },
    {
        path: 'activate',
        loadComponent: () => import('./features/auth/activate-account/activate-account.component').then(m => m.ActivateAccountComponent)
    },
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [authGuard],
        children: [
            {
                path: 'home',
                loadChildren: () => import('./features/home/home.routes').then(m => m.routes)
            },
            {
                path: 'inspection-report',
                canMatch: [roleMatchGuard],
                data: {
                    roles: [ROLES.ADMIN, ROLES.CS, ROLES.OPS]
                },
                loadChildren: () => import('./features/inspection-report/inspection-report.routes').then(m => m.routes)
            },
            {
                path: 'video-call',
                loadComponent: () => import('./features/video-call/video-call.component').then(m => m.VideoCallComponent)
            },
            {
                path: 'organization',
                canMatch: [roleMatchGuard],
                data: {
                    roles: [ROLES.SUPER_ADMIN]
                },
                loadChildren: () => import('./features/manage-organization/manage-organization.routes').then(m => m.routes)
            },
            {
                path: 'audit-logs',
                canMatch: [roleMatchGuard],
                data: {
                    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.OPS]
                },
                loadChildren: () => import('./features/audit-logs/audit-logs.routes').then(m => m.routes)
            },
            {
                path: 'inspections',
                canMatch: [roleMatchGuard],
                data: {
                    roles: [ROLES.ADMIN, ROLES.CS, ROLES.OPS]
                },
                loadChildren: () => import('./features/inspections/inspections.routes').then(m => m.routes)
            },
            {
                path: 'driver-logs',
                canMatch: [roleMatchGuard],
                data: {
                    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.OPS]
                },
                loadChildren: () => import('./features/driver-logs/driver-logs.routes').then(m => m.routes)
            },
            {
                path: 'load-logs',
                canMatch: [roleMatchGuard],
                data: {
                    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.OPS]
                },
                loadChildren: () => import('./features/load-logs/load-logs.routes').then(m => m.routes)
            },
            {
                path: 'users',
                canMatch: [roleMatchGuard],
                data: {
                    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN]
                },
                loadChildren: () => import('./features/user-management/user-management.routes').then(m => m.routes)
            },
            {
                path: 'carrier-master',
                canMatch: [roleMatchGuard],
                data: {
                    roles: [ROLES.ADMIN]
                },
                loadChildren: () => import('./features/carrier-master/carrier-master.routes').then(m => m.routes)
            },
            {
                path: 'settings',
                canMatch: [roleMatchGuard],
                data: {
                    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN]
                },
                loadChildren: () => import('./features/settings/settings.routes').then(m => m.routes)
            },
            {
                path: 'bulk-import',
                canMatch: [roleMatchGuard],
                data: {
                    roles: [ROLES.ADMIN]
                },
                loadChildren: () => import('./features/bulk-import/bulk-import.routes').then(m => m.routes)
            },
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full'
            }
        ]
    },
    {
        path: '**',
        redirectTo: 'home'
    }
];
